import type { SuretyBondFormTemplateId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useCallback, useRef } from "react";
import { useRequest } from "../../../utils/request";
import type { BondFormTemplatePreview } from "./types";

// Kept imperative rather than a useQuery: the response is a short-lived signed URL,
// so caching it would hand out expired links.
export const useOpenBondFormTemplatePreview = () => {
	const { get } = useRequest();
	const { isAdmin } = useAuthenticatedUser();
	const getRef = useRef(get);
	getRef.current = get;

	const openPreview = useCallback(
		async (templateId: SuretyBondFormTemplateId) => {
			const path = isAdmin
				? `/v2/admin/surety/bond-forms/templates/${templateId}/preview`
				: `/v2/surety/bond-forms/templates/${templateId}/preview`;
			try {
				const preview = await getRef.current<BondFormTemplatePreview>(path);
				window.open(preview.url, "_blank", "noopener,noreferrer");
			} catch (error) {
				console.error("Failed to fetch bond form template preview", error);
			}
		},
		[isAdmin],
	);

	return { openPreview };
};
